import { useEffect } from "react";

import { getTracking } from "helpers/tracking";
import { useStoreActions } from "store/store";

// Captures marketing attribution (hubspotutk cookie + UTM params + Bing/Google
// click ids) on mount and stores it so updateCartThunk forwards it to the hub.
// Mirrors useAffiliateId. Runs once; the underlying values are persisted in a
// cookie by the helper, so they survive reloads and multi-step navigation.
export const useTracking = () => {
  const setTracking = useStoreActions((a) => a.setTracking);

  useEffect(() => {
    setTracking(getTracking());
  }, [setTracking]);
};
